import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS} from 'apollo-angular';
import {ApolloClientOptions, ApolloLink, DefaultOptions, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {onError} from '@apollo/client/link/error';
import {environment} from '../environments/environment';
import {ConfirmationService} from 'primeng/api';

const uri = environment.graphql_url; // <-- add the URL of the GraphQL server here



export function createApollo(httpLink: HttpLink, confirmationService: ConfirmationService): ApolloClientOptions<any> {

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      console.log('graphQLErrors', graphQLErrors);

      if (graphQLErrors.map(m => m.extensions?.statusCode).some(u => u === 500)) {
        // this.errorCode = x.errors[0].extensions?.code;
        console.log('pumasok here');
        confirmationService.confirm({
          message: graphQLErrors[0].message,
          acceptVisible: false,
          rejectVisible: false,
          icon: 'fa-regular fa-face-anxious-sweat',
          closeOnEscape: false,
          key: '500Dialog'
        });
      }
    }
    if (networkError) {
      console.log('networkError', networkError);
    }
  });

  const link = ApolloLink.from([errorLink, httpLink.create({uri})]);

  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    }
  };


  return {
    // link: httpLink.create({uri}),
    link,
    cache: new InMemoryCache({
      addTypename: false
    }),
    connectToDevTools: true,
    defaultOptions,
  };
}

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, ConfirmationService],
    },
  ],
})
export class GraphQLModule {}
